export const useLocationSearchSettings = () => {

  const config = useRuntimeConfig()
  
  const transform = (response) => {
    const {sanitize} = useUtils();
    const result = {
      id: response.data.id,        
      resultsReturnedTitle: response.data.attributes.resultsReturnedTitle,
      resultsAdditionalMessage: response.data.attributes.resultsAdditionalMessage,
      noResultsAvailable: response.data.attributes.noResultsAvailable,
      definedMatches: response.data.attributes.definedMatches.map((element) => {
        return {
          searchWords: element.searchWords,
          locations: element.locations.data.map((locationData) => {
            return {
              id: locationData.id,
              name: locationData.attributes.name,
              slug: locationData.attributes.slug,
              description: locationData.attributes.description,
              listingImage: locationData.attributes.listingImage,
              pulseLocation: locationData.attributes.pulseLocation,
            }
          })
        }
        
      }),
      heroHeader: sanitize(response.data.attributes.heroHeader),
      jumpToTop: response.data.attributes.jumpToTop,
      displayHero: response.data.attributes.displayHero,
      brochureRibbon: response.data.attributes.brochureRibbon,
      brochureRibbonTags: response.data.attributes.brochureTags,
      seo: sanitize(response.data.attributes.seo)
    } 
    
    return result;
    
  }

  

  const locationSearchData = async (deep = true) => {    
    const url = '/api/location-settings';
    
    if (config.public.nuxtEnvironment === 'production') {
      return await useFetch(url, {
        method: 'GET',
        baseURL: config.public.nuxtAPIUrl,      
        transform: transform
      });
    }

    return await useFetch(url, {
      method: 'GET',
      transform: transform
    });
  }

  const getLocationSearchLocal = async () => {
    if (config.public.nuxtEnvironment === 'production') {
      return await useFetch('/api/location-search', {
        baseURL: config.public.nuxtAPIUrl,
      })
    }

    return await useFetch('/api/location-search')
  }

  const setLocationSearchLocal = async (data) => {
    if (config.public.nuxtEnvironment === 'production') {
      return await useFetch('/api/location-search', {
        method: 'post',
        baseURL: config.public.nuxtAPIUrl,
        body: data
      })
    }

    return await useFetch('/api/location-search', {
      method: 'post',
      body: data
    })
  }

  return {
    setLocationSearchLocal,
    getLocationSearchLocal,
    locationSearchData
  }
}